const popupHint = () => {
  const hintBtn = document.getElementById('doubleSumHintBtn');
  const popup = document.getElementById('doubleSumHintPopup');
  const popupClose = document.getElementById('doubleSumHintClose');

  if (!hintBtn) return;

  hintBtn.addEventListener('click', () => {
    popup.classList.add('is-active');

    // scroll-margin-top holds the sticky header's height; a popup top under the header is hidden.
    const rect = popup.getBoundingClientRect();
    const headerInset = parseFloat(getComputedStyle(popup).scrollMarginTop) || 0;
    const isFullyVisible = rect.top >= headerInset && rect.bottom <= window.innerHeight;

    if (!isFullyVisible) {
      popup.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  popupClose.addEventListener('click', () => {
    popup.classList.remove('is-active');
  });
};

export default popupHint;
